'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Default as mcs style
var gray = {
  black: '#353630',
  grayDark: '#999A94',
  grayBase: '#D1D2D3',
  grayLight: '#FAFAFA',
  white: '#FFFFFF'
};

var kind = exports.kind = {
  default: gray.grayLight,
  primary: '#00A1DE',
  success: '#69BE28',
  error: '#F5364E',
  warning: '#F39A1E'
};

var base = {
  bodyBackgroundColor: '#F1F2F7',
  bodyColor: gray.black,
  fontSize: '13px',
  lineHeight: 1.5
};

var height = {
  normal: '32px',
  small: '20px',
  header: '50px'
};

var fontSize = {
  small: '0.923rem',
  p: '1rem',
  h6: '1rem',
  h5: '1rem',
  h4: '1.15rem',
  h3: '1.38rem',
  h2: '1.69rem',
  h1: '2.46rem'
};

var mobile = {
  maxWidth: '800px',
  headerHeight: '56px'
};

exports.default = {
  color: _extends({}, gray, kind),
  base: base,
  fontSize: fontSize,
  height: height,
  mobile: mobile
};


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-theme/lib/theme.js
// module id = 164
// module chunks = 4